import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

import {
  type FacilityUserInternalNotesResponse,
  facilityUserInternalNotesResponseSchema,
} from "../types";

export const GET_FACILITY_USER_INTERNAL_NOTES_URL = `${environmentConfig.REACT_APP_API_MAIN_URL}/api/facility-user-internal-notes/:facilityUserId-:workplaceId`;

export const getFacilityUserInternalNotesParamsSchema = z.object({
  facilityUserId: z.string(),
  workplaceId: z.string(),
});
export type GetFacilityUserInternalNotesParams = z.infer<
  typeof getFacilityUserInternalNotesParamsSchema
>;

export const getFacilityUserInternalNotesUrl = (params: GetFacilityUserInternalNotesParams) =>
  GET_FACILITY_USER_INTERNAL_NOTES_URL.replace(":facilityUserId", params.facilityUserId).replace(
    ":workplaceId",
    params.workplaceId
  );

export function useGetFacilityUserInternalNotes(
  params: GetFacilityUserInternalNotesParams,
  options: UseGetQueryOptions<FacilityUserInternalNotesResponse> = {}
) {
  return useGetQuery({
    url: getFacilityUserInternalNotesUrl(params),
    responseSchema: facilityUserInternalNotesResponseSchema,
    meta: { logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_USER_INTERNAL_NOTES_FAILURE },
    ...options,
  });
}
